import React from 'react';

const AllianceVoting = () => {
  return <h1>AllianceVoting Page</h1>;
};

export default AllianceVoting;
